import { render, staticRenderFns } from "./ReplacementDetails.vue?vue&type=template&id=32744b9c&"
import script from "./ReplacementDetails.vue?vue&type=script&lang=js&"
export * from "./ReplacementDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports